import { commonReducer, initialCommonState } from './commonReducer';
import { tableReducer, initialTableState } from './table-reducer';

import { pipReducer, initialPipState } from './pip-reducer';
import { forceLogoutReducer, initialForceLogoutState } from './forceLogoutReducer';

// Combined initial state
export const initialState = {
    common: initialCommonState,
    table: initialTableState,

    sendData: () => {},
    useSocket: () => ({off: () => {}, refresh: () => {}}),
    ID: '',
    SOCKET_ID: '',
    ISA: false,
    S3_BASE_URL: '',
    // Add more state slices as needed
    pip: initialPipState,
    forceLogout: initialForceLogoutState,
};

// Combined reducer that delegates to specific reducers
export const UFrameworkReducer = (state, action) => {
    return {
        ...state,
        common: commonReducer(state.common, action),
        table: tableReducer(state.table, action),

        // Add more reducers as needed
        pip: pipReducer(state.pip, action),
        forceLogout: forceLogoutReducer(state.forceLogout, action),
    };
};